import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CodaltComponent } from 'src/app/codalt.component';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-settlement-send-all',
    templateUrl: './settlement-send-all.component.html',
    styleUrls: ['./settlement-send-all.component.scss'],
    standalone: false,
})
export class SettlementSendAllComponent extends CodaltComponent implements OnInit {
    endDate: Date;

    constructor(private title: Title) {
        super();
        this.title.setTitle('Versturen' + environment.titleAppend);
    }

    ngOnInit(): void {
        this.endDate = new Date();
    }
}
